function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 64 64"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 0h48a8 8 0 018 8v48a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8zm46.457 16.225c1.562 1.562 1.64 4.016.176 5.48L28.117 48.222c-.91.909-2.2 1.223-3.42.957l-.196-.042a3.735 3.735 0 01-1.763-.99L9.1 34.508c-1.507-1.506-1.461-3.994.1-5.556 1.563-1.562 4.05-1.607 5.557-.1L25.465 39.56l23.512-23.511c1.464-1.465 3.918-1.386 5.48.176z",
  fill: "#2071bd",
  fillRule: "evenodd"
})));